import * as React from 'react';
import { Typography } from '../../../Typography/Typography.js';
import { useSubtitleElement } from './useSubtitleElement.js';

var SubtitleElementView = function SubtitleElementView(_ref) {
  var title = _ref.title,
    disabled = _ref.disabled;
  var _useSubtitleElement = useSubtitleElement({
      title: title,
      disabled: disabled
    }),
    content = _useSubtitleElement.content,
    variant = _useSubtitleElement.variant,
    textColor = _useSubtitleElement.textColor;
  if (!content) return null;
  return /*#__PURE__*/React.createElement(Typography, {
    variant: variant,
    textColor: textColor,
    mt: "4"
  }, content);
};
var SubtitleElement = /*#__PURE__*/React.memo(SubtitleElementView);

export { SubtitleElement };
//# sourceMappingURL=SubtitleElement.js.map
